import React from "react";
import { ArrowBack, Download, OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import "./Demo.css";

const REPORT_URL =
  "https://farmology.ai/static/SampleReport/personalised_farm_advisory_report.pdf";

export default function DemoReport() {
  return (
    <main className="farmology-report-page">
      {/* =====================================================
          HERO
      ====================================================== */}
      <section className="report-hero">
        <div className="report-hero-overlay"></div>

        <div className="report-container report-hero-content">
          <div className="report-hero-eyebrow">
            <span></span>
            FARMOLOGY REPORT
          </div>

          <h1>
            Your farm.
            <br />
            <span>Better informed.</span>
          </h1>

          <p>
            Explore a personalised farm advisory report with insights designed
            to help you understand your field and make better farming decisions.
          </p>

          <div className="report-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Farm Advisory Report</span>
          </div>
        </div>

        <div className="report-hero-number">05</div>

        <div className="report-hero-bottom">
          <span>FARMOLOGY</span>
          <div></div>
          <span>SMART AGRICULTURE</span>
        </div>
      </section>

      {/* =====================================================
          REPORT PREVIEW
      ====================================================== */}
      <section className="report-preview-section">
        <div className="report-container">
          <div className="report-section-heading">
            <div>
              <span className="report-eyebrow">
                <span></span>
                SAMPLE REPORT
              </span>

              <h2>Personalised farm advisory</h2>

              <p>
                Preview a sample Farmology advisory report below. The report
                brings farm intelligence and actionable insights together in one
                place.
              </p>
            </div>

            <div className="report-actions">
              <a
                href={REPORT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="report-action report-action-secondary"
              >
                <OpenInNew />
                Open PDF
              </a>

              <a
                href={REPORT_URL}
                download
                className="report-action report-action-primary"
              >
                <Download />
                Download
              </a>
            </div>
          </div>

          {/* PDF VIEWER */}
          <div className="report-viewer-wrapper">
            <div className="report-viewer-topbar">
              <div className="report-viewer-file">
                <span className="report-file-icon">PDF</span>

                <div>
                  <strong>Personalised Farm Advisory Report</strong>
                  <span>Farmology sample report</span>
                </div>
              </div>

              <a
                href={REPORT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="report-viewer-open"
              >
                <OpenInNew />
                Open in new tab
              </a>
            </div>

            <div className="report-pdf-frame">
              <iframe
                src={`${REPORT_URL}#toolbar=1&navpanes=0&scrollbar=1`}
                title="Personalised Farm Advisory Report"
                loading="lazy"
              />
            </div>
          </div>

          <div className="report-preview-note">
            <span>FARMOLOGY</span>

            <p>
              This is a sample advisory report preview. Actual reports can
              contain farm-specific insights based on your field and crop.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
